export default {
	subtitle: "Credit card transactions in Chile",
  path: "transaction_cc_cl",
	paragraphs: [
    "To create transactions using a Chilean credit card, you have two options: utilize the provided API call, exemplified below, or opt for the checkout page sample available on our sandbox portal or via the following link. We highly recommend testing the checkout page first before initiating direct API calls, because you can adapt it to your front-end environment.",
    "There are also 2 possible flows for payment: one-time payment and tokenization, each one with a full working HTML example. You can find further instructions on the HTML sample pages.",
    'Check in the "Customers" section for the required information you need to collect from your customers to enable the creation of a card transaction since the 3DS validation is implemented in CLP card transactions.'
  ],
  hyperlink: {
    linkPath: "/static/3DSSamplesCL.zip",
    linkText: "Download sample page"
  },
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload: {
        "transaction": {
          "currency": "CLP",
          "exchange_currency": "USD",
          "value": "30000",
          "from_credit_card": {
            "card_number": "4456524869770255",
            "card_expiration_date": "03/30",
            "card_security_code": "345",
            "card_brand": "Visa",
            "fullname": "Muñoz Perez Izidro"
          },
          "threeds": { "jwt": "eyJhbGciOiJIUzI1NiIsInR5cC..."
          },
          "to_bank_account_id": "{{partner_usd_account_id}}",
          "subject_id": "{{cl_person_id}}"
        }
    },
    responses: {
      "data": {
        "value": "30000",
        "to_bank_account": {
          "routing_number": "021000021 - Special instruction: SFTB000001",
          "pix_info": null,
          "owner_name": null,
          "owner_document_type": null,
          "owner_document_number": null,
          "owner_company": {
            "social_name": "POWER HOME THEATER",
            "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
            "document_type": "tax_id",
            "document_number": "2348909854385"
          },
          "nickname": null,
          "intermediary_bank_account": null,
          "id": "4af245f8-de8b-45f5-8ba7-58003d325b12",
          "iban": null,
          "currency": "USD",
          "branch_number": null,
          "branch_country": "CHL",
          "bank": {
            "swift": "CHASUS33",
            "name": "JPMorgan Chase Bank",
            "ispb": null,
            "id": "e6a25c9c-e5f2-49db-a24e-c8710a18b6a8",
            "country": null,
            "code": null
          },
          "account_type": "conta-corrente",
          "account_number": "10000344906926",
          "aba": null
        },
        "threeds_challenge": {
          "three_ds_version": "1.0.2",
          "secure_id": "3a141ce3-cc10-4793-97b6-acc709d262a8",
          "pareq": "sandbox",
          "authentication_transaction_id": "OWgXwASsYPW4hr1ATcf0",
          "auth_required": true,
          "acs_url": ""
        },
        "subject_is_receiver": false,
        "subject_id": "4a42a549-09fa-489f-a22a-3557d2323443",
        "subject": {
          "updated_at": "2025-07-10T22:02:08.671256",
          "status": "approved",
          "social_name": "Muñoz Perez",
          "required_clearance_level": 1,
          "references": [],
          "phone_number": "675675",
          "phone_country_code": "32",
          "phone_area_code": "56",
          "partners": [],
          "net_value": "0.00",
          "net_monthly_average_income": "0.00",
          "natural_person": true,
          "main_activity": null,
          "inserted_at": "2025-02-14T12:15:40.779049",
          "id": "4a42a549-09fa-489f-a22a-3557d2323443",
          "fiscal_country": "Chile",
          "email": "munoz.isidro@gmail.com",
          "document_type": "rut",
          "document_number": "112934596",
          "creation_date": "1994-09-18",
          "company_type": "ltda",
          "company_name": "Muñoz Perez",
          "clearance_level": 1,
          "address_street": "Parcela 1 Sector Huaqui Los Angeles",
          "address_state": "PQ",
          "address_postal_code": "64345",
          "address_number": "2251",
          "address_neighborhood": "Santa Ines",
          "address_country": "Chile",
          "address_complement": null,
          "address_city": "Sausalito",
          "activity_type": "outros"
        },
        "status": "pending",
        "source_name": "Muñoz Perez",
        "source_document_type": "rut",
        "source_document_number": "112934596",
        "payment_method": null,
        "meta": null,
        "inserted_at": "2025-07-10T22:02:08.659847",
        "id": "151e99e5-67c2-4e66-94c1-01849d8e8c43",
        "from_credit_card": {
          "status": "tokenized",
          "masked_card_number": "445652******0255",
          "inserted_at": "2025-07-10T22:02:08.658377",
          "id": "1c56114f-9805-480a-a46c-5782005ba6c9"
        },
        "from_bank_account": null,
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "CLP",
        "cleared": true,
        "bank_transaction": null
      }
    }
  },
  parameterPayload: [
    {
      name: "threeds",
      type: "object",
      required: true,
      description: "An object containing only the jwt token. You will get that token on the front-end"
    }
  ],
  domainsProperties: [
    {
      name: "4456528080389860, 4456529267234200, 4456529165328302, 4456524869770255, 5451951574925480",
      values: "Valid test cards that will trigger the 3ds OTP validation"
    },
    {
      name: "4456540000000063, 4456541249811088, 4456543371713314, 4456541982068615",
      values: "Valid test cards that will always approve, skipping the 3ds OTP validation"
    },
    {
      name: "4456530000000031, 4456530000000106, 4456536583667765, 4456536501449767",
      values: "Test cards that will fail the 3DS validation"
    },
    {
      name: "4456523340069956, 4456541249811088",
      values: "Test cards that will always fail"
    },
    {
      name: "4349003000047015, 4349001210846432, 4349001386781322, 4349003243371321",
      values: "Test cards that will always fail and the reason will be disclosed"
    },
    {
      name: "4574441215190335",
      values: "Test card that will fail tokenization"
    },
    {
      name: "4349003000047015",
      values: "Test card that can be tokenized but will fail in a further transaction"
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardCHL.js